import { Box, FormControl, MenuItem, Select } from '@mui/material'

/**
 * The PurchaseOrdersSortBy component
 * @component
 *
 * @param {Object} props
 * @param {string} props.sortBy
 * @param {function} props.handleSortByChange

 * @returns {JSX.Element}
 */

const PurchaseOrdersSortBy = ({ sortBy, handleSortByChange }) => {
  return (
    <Box
      component="form"
      noValidate
      autoComplete="off"
      sx={{
        display: 'flex',
        alignItems: 'end',
        gap: 0.5,
        flexDirection: 'column',
        p: 2,
      }}
    >
      <FormControl sx={{ width: '49.5%' }}>
        <Select
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              display: 'none',
            },
          }}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={sortBy || '-fecha_pedido'}
          label="Ordenar por: "
          onChange={(e) => {
            handleSortByChange(e.target.value)
          }}
        >
          <MenuItem key={'serie_asc'} value={'serie_numeracion'}>
            Serie Asc.
          </MenuItem>
          <MenuItem key={'serie_desc'} value={'-serie_numeracion'}>
            Serie Desc.
          </MenuItem>
          <MenuItem key={'numero_asc'} value={'numero_pedido'}>
            Nº Asc.
          </MenuItem>
          <MenuItem key={'numero_desc'} value={'-numero_pedido'}>
            Nº Desc.
          </MenuItem>
          <MenuItem key={'fecha_asc'} value={'fecha_pedido'}>
            Fecha Asc.
          </MenuItem>
          <MenuItem key={'fecha_desc'} value={'-fecha_pedido'}>
            Fecha Desc.
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

export default PurchaseOrdersSortBy
